export default "__VITE_ASSET__BGX$T4fb__"